import React from 'react';
import PageHeader from '../../../layout/shared/page-header';
import { menuRoutes } from '../../../router/menu';
import DocumentTypesList from './DocumentTypesList';

const DocumentTypesSettingsPage: React.FC = () => {
    const pageHeader = {
        title: 'Ajustes de Tipos de Documentos',
        breadcrumb: [
            { name: 'Inicio', href: menuRoutes.dashboard.path },
            { name: 'Configuración' },
            { name: 'Tipos de documentos', href: menuRoutes.settings.path + menuRoutes.settings.document_types },
        ]
    };

    return (
        <div className='h-full overflow-auto scrollbar'>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
                className='border-b-4 border-dotted border-grey-500 top-0'
            />

            <div className="p-6">
                <DocumentTypesList />
            </div>
        </div>
    );
};

export default DocumentTypesSettingsPage;
